import axios, { AxiosInstance } from "axios";
import { store } from "../redux/store";
import { getConfig } from "../config"

let instance: AxiosInstance | null = null;

const getInstance = (): AxiosInstance => {
  if (!instance || process.env.NODE_ENV === 'development') {
    
    const { BaseBffUrl, PortalBaseUrl } = getConfig();

    instance = axios.create({
      baseURL: BaseBffUrl,
      headers: {
        "Access-Control-Allow-Origin": `"${PortalBaseUrl}"`,
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        "X-CSRF": "1",
      },
      withCredentials: true
    });

    instance.interceptors.request.use((request) => {
      if (!request.params) {
        request.params = {};
      }
      if (!request.params.companyId)
        request.params.companyId = store.getState()?.account?.selectedCompanyId;
      return request;
    });

    instance.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        if (response.data.items) {
          const { items, ...extraData } = response.data;
          response.data = items;
          //@ts-expect-error
          response.extraData = extraData;
        }
        return response;
      },
      function (error) {
        if (error?.response?.status === 401) {
          //TODO: used to be /bff/login should the return url be set here too? /returnurl=error.request.url ?
          window.location.href = "/login";
        }
        
        //Forbidden
        if (error?.response?.status === 403) {
          window.location.href = "/noaccess";
        }
        throw error;
      }
    );
  }
  return instance;
};


// Proxy so callers can use protectAxios.get() / .post() etc
// without changing any existing code
const protectAxios = new Proxy({} as AxiosInstance, {
  get: (_target, prop) => {
    const instance = getInstance();
    const value = (instance as any)[prop];
    // Bind to the instance so methods like delete work correctly
    return typeof value === 'function' ? value.bind(instance) : value;
  }
});

export default protectAxios;
